import { render, staticRenderFns } from "./city-choose.vue?vue&type=template&id=719f695c&scoped=true&"
import script from "./city-choose.vue?vue&type=script&lang=ts&"
export * from "./city-choose.vue?vue&type=script&lang=ts&"
import style0 from "./city-choose.vue?vue&type=style&index=0&id=719f695c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719f695c",
  null
  
)

export default component.exports